import React from 'react';
import { useTranslation } from 'react-i18next';
import dataCaptured from '../../../resources/analytics-icons/captured-data.png';
import videoViews from '../../../resources/analytics-icons/video-views.png';
import polls from '../../../resources/analytics-icons/polls.png';
import connections from '../../../resources/analytics-icons/connections.png';
import users from '../../../resources/analytics-icons/unique-users.png';
import TopWidget from './TopWidget';
import useStyles from './styles';


const TopWidgetPanelContainer = ({ data }) => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  return (
    <div className={classes.topWidgetContainer}>
      <TopWidget
        title={t('ANALYTICS.DATA_CAPTURED')}
        value={t('COMMON.INTL_CURRENCY', { value: data.dataCaptured })}
        icon={dataCaptured}
        tooltipText={t('ANALYTICS.DATA_CAPTURED_TOOLTIP')}
      />
      <TopWidget
        title={t('ANALYTICS.VIDEO_VIEWS')}
        value={t('COMMON.INTL_CURRENCY', { value: data.videoViews })}
        icon={videoViews}
        tooltipText={t('ANALYTICS.VIDEO_VIEWS_TOOLTIP')}
      />
      <TopWidget
        title={t('ANALYTICS.POLLS')}
        value={t('COMMON.INTL_CURRENCY', { value: data.polls })}
        icon={polls}
        tooltipText={t('ANALYTICS.POLLS_TOOLTIP')}
      />
      <TopWidget
        title={t('ANALYTICS.MONTHLY_CONNECTIONS')}
        value={t('COMMON.INTL_NUMBER', { value: data.monthlyConnections })}
        icon={connections}
      />
      <TopWidget
        title={t('ANALYTICS.UNIQUE_USERS')}
        value={t('COMMON.INTL_NUMBER', { value: data.uniqueUsers })}
        icon={users}
      />
    </div>
  );
};


export default TopWidgetPanelContainer;
